export enum ConnectableStatus {
    CONNECTABLE = 'CONNECTABLE', // The venue exists on our provider as a subscription (Hyperline) so it can be connected
    NOT_CONNECTABLE = 'NOT_CONNECTABLE', // The venue exists on Google or Facebook but not as a subscription (Hyperline) so it can't be connected
    ALREADY_CONNECTED = 'ALREADY_CONNECTED', // The venue is already connected
}

export enum LocationVerificationStatus {
    VERIFIED = 'VERIFIED',
    PENDING = 'PENDING',
    REJECTED = 'REJECTED',
    DELETED = 'DELETED',
}
